/**
 *
 * Email Integration
 *
 */

import React, { FC, useCallback, useEffect, useState } from 'react';

import { Clients } from '@ariksa/notification';
import { ClientsApiEditClientRequest } from '@ariksa/notification/api';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectIntegrations } from 'containers/Setup/Integrations/selectors';

import { actions as clientActions } from '../../../slice';

import { EmailForm } from './EmailForm';

export const EditEmailGroup: FC = () => {
  const { activeClient } = useSelector(selectIntegrations);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [emailIDs, setEmailIDs] = useState<string[]>([]);
  const { data: currentRecord } = activeClient;

  useEffect(() => {
    setEmailIDs(currentRecord?.email?.email_group ?? []);
  }, [currentRecord]);

  const setEmails = useCallback(emails => {
    setEmailIDs(emails);
  }, []);

  const onSubmit = data => {
    const payload: ClientsApiEditClientRequest = {
      uuid: currentRecord?.uuid,
      editClientConfig: {
        name: data.name,
        status: true,
        email: {
          email_group: emailIDs,
        },
      },
    };
    dispatch(
      clientActions.updateClientById({
        q: payload,
        onSuccess: () => navigate('/setup/integrations/' + Clients.Email),
      }),
    );
  };

  return (
    <EmailForm
      onSubmit={onSubmit}
      emailIDs={emailIDs}
      setEmailIDs={setEmails}
      actionType="Update"
    />
  );
};
